"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/web.timers.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _areEqual = _interopRequireDefault(require("fbjs/lib/areEqual"));

var _affix = _interopRequireDefault(require("antd/lib/affix"));

var _drawer = _interopRequireDefault(require("antd/lib/drawer"));

var _color = _interopRequireDefault(require("color"));

var _link = require("@meepshop/link");

var _Sensor = _interopRequireDefault(require("@meepshop/context/lib/Sensor"));

var _withHook = _interopRequireDefault(require("@store/utils/lib/withHook"));

var _withContext = _interopRequireDefault(require("@store/utils/lib/withContext"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _menu = _interopRequireDefault(require("../menu"));

var _propTypes2 = require("../constants/propTypes");

var _searchDrawer = _interopRequireDefault(require("./searchDrawer"));

var _constant = require("./constant");

var _getPages = _interopRequireDefault(require("./utils/getPages"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _MobileMenu = _interopRequireDefault(require("./components/MobileMenu"));

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "header": "meepshop-meep-ui__mobileLayout-index__header",
  "barsIcon": "meepshop-meep-ui__mobileLayout-index__barsIcon",
  "logo": "meepshop-meep-ui__mobileLayout-index__logo",
  "image": "meepshop-meep-ui__mobileLayout-index__image",
  "headerMenu": "meepshop-meep-ui__mobileLayout-index__headerMenu",
  "drawer": "meepshop-meep-ui__mobileLayout-index__drawer",
  "member": "meepshop-meep-ui__mobileLayout-index__member",
  "menu": "meepshop-meep-ui__mobileLayout-index__menu",
  "search": "meepshop-meep-ui__mobileLayout-index__search",
  "searchHeader": "meepshop-meep-ui__mobileLayout-index__searchHeader",
  "searchContent": "meepshop-meep-ui__mobileLayout-index__searchContent",
  "sidebar": "meepshop-meep-ui__mobileLayout-index__sidebar",
  "showIcon": "meepshop-meep-ui__mobileLayout-index__showIcon"
};
var MobileLayout = (_dec = (0, _withHook["default"])(function () {
  return {
    router: (0, _link.useRouter)()
  };
}), _dec2 = (0, _withContext["default"])(_Sensor["default"]), _dec(_class = _dec2(_class = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(MobileLayout, _React$PureComponent);

  var _super = _createSuper(MobileLayout);

  function MobileLayout() {
    var _this;

    (0, _classCallCheck2["default"])(this, MobileLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      visible: false,
      memberPages: [],
      showSearchContent: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPages", (0, _memoizeOne["default"])(_getPages["default"], _areEqual["default"]));
    return _this;
  }

  (0, _createClass2["default"])(MobileLayout, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var asPath = this.props.router.asPath;
      if (asPath !== prevProps.router.asPath) setTimeout(function () {
        if (!_this2.isUnmounted) _this2.setState({
          visible: false
        });
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _fixedtop$menu;

      var _this$props = this.props,
          colors = _this$props.colors,
          mobileLogoUrl = _this$props.storeSetting.mobileLogoUrl,
          fixedtop = _this$props.fixedtop,
          secondtop = _this$props.secondtop,
          sidebar = _this$props.sidebar,
          children = _this$props.children,
          isMobile = _this$props.isMobile;
      var _this$state = this.state,
          visible = _this$state.visible,
          memberPages = _this$state.memberPages,
          showSearchContent = _this$state.showSearchContent;

      var _this$getPages = this.getPages(fixedtop, secondtop, sidebar, this.props),
          pages = _this$getPages.pages,
          headerPages = _this$getPages.headerPages,
          _this$getPages$design = _this$getPages.design,
          expandSubItem = _this$getPages$design.expandSubItem,
          design = (0, _objectWithoutProperties2["default"])(_this$getPages$design, ["expandSubItem"]);

      var mobileSettings = (design === null || design === void 0 ? void 0 : design.mobileSettings) || {}; // 舊的資料沒有 mobileSettings 的設定

      var normal = {
        color: mobileSettings.color || colors[2],
        background: mobileSettings.background || colors[1]
      };
      var drawerStyle = {
        '--drawer-background': normal.background,
        '--drawer-color': normal.color,
        '--drawer-color-rgb': _color["default"].rgb(normal.color).array()
      };
      var expandType = mobileSettings.expandType || _constant.EXPAND_TYPE.FULL;
      var pageMenuProps = {
        pages: pages,
        useIcon: mobileSettings.useIcon || false,
        color: normal.color,
        background: normal.background,
        open: visible,
        onClose: function onClose() {
          return _this3.setState({
            visible: false
          });
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_affix["default"], {
        offsetTop: 0
      }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
        settings: mobileSettings,
        showBar: pages.length !== 0,
        showSearchbar: design === null || design === void 0 ? void 0 : design.showSearchbar,
        isMenuOpen: visible,
        onMenuClick: function onMenuClick() {
          return _this3.setState({
            visible: !visible
          });
        },
        onSearchClick: function onSearchClick() {
          return _this3.setState({
            showSearchContent: true
          });
        },
        pages: headerPages,
        iconSize: fixedtop === null || fixedtop === void 0 ? void 0 : (_fixedtop$menu = fixedtop.menu) === null || _fixedtop$menu === void 0 ? void 0 : _fixedtop$menu.iconSize,
        onMemberClick: function onMemberClick(memberNewPages) {
          return _this3.setState({
            memberPages: memberNewPages
          });
        }
      })), children, isMobile && /*#__PURE__*/_react["default"].createElement(_MobileMenu["default"], (0, _extends2["default"])({
        open: visible,
        expandType: expandType
      }, pageMenuProps)), /*#__PURE__*/_react["default"].createElement(_drawer["default"], {
        className: "".concat(styles.drawer, " ").concat(styles.member),
        onClose: function onClose() {
          return _this3.setState({
            memberPages: []
          });
        },
        visible: memberPages.length !== 0,
        placement: "top",
        height: "100%"
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], {
        id: "mobile-member",
        className: styles.menu,
        pages: memberPages,
        design: _objectSpread(_objectSpread({}, design), {}, {
          showLogo: Boolean(mobileLogoUrl),
          showSearchbar: false,
          expandSubItem: true,
          normal: normal,
          width: 150,
          height: 60
        })
      }), /*#__PURE__*/_react["default"].createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: "\n            .".concat(styles.member, " .").concat(styles.menu, " .logo {\n              border-bottom: 2px solid ").concat((0, _color["default"])(colors[2]).alpha(0.1), ";\n            }\n\n            .").concat(styles.member, " .").concat(styles.menu, " .menu-1:not(:last-child) {\n              border-bottom: 2px solid ").concat((0, _color["default"])(colors[2]).alpha(0.2), ";\n            }\n          ")
        }
      })), /*#__PURE__*/_react["default"].createElement(_searchDrawer["default"], {
        showSearchContent: showSearchContent,
        closeDrawer: function closeDrawer() {
          return _this3.setState({
            showSearchContent: false
          });
        },
        drawerStyle: drawerStyle
      }), /*#__PURE__*/_react["default"].createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: "\n            --search-drawer-bg-color: ".concat(normal.background, ";\n            .").concat(styles.drawer, " .ant-drawer-content {\n              background: ").concat(normal.background, ";\n            }\n          ")
        }
      }));
    }
  }]);
  return MobileLayout;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** context */
  colors: _propTypes["default"].arrayOf(_propTypes2.COLOR_TYPE.isRequired).isRequired,
  storeSetting: _propTypes2.STORE_SETTING_TYPE.isRequired,

  /** props */
  fixedtop: _propTypes["default"].shape({}),
  secondtop: _propTypes["default"].shape({}),
  sidebar: _propTypes["default"].shape({}),
  children: _propTypes["default"].node.isRequired
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  fixedtop: null,
  secondtop: null,
  sidebar: null
}), _temp)) || _class) || _class) || _class);
exports["default"] = MobileLayout;